export const cn = {
    personal_basic: {
        title: '升级',
        heading: '解锁完整分析工具',
        description: '此功能为专业版专属。升级以全面掌控您的工作流程。',
        features: {
            0: '每日使用额度最高提升7.5倍',
            1: '文档精读功能扩展（每次至多上传5个文件）',
            2: 'Lead化合物分析开放导出（每月5次）',
            3: '5份AI驱动情报简报（每周更新）',
        },
        recommendation: '推荐',
        upgradeButton: '升级至专业版',
    },
    personal_pro: {
        title: '升级',
        heading: '通过企业版释放可量化的规模价值',
        description: '升级以获取端到端科研工作流与组织级协作能力。',
        features: {
            0: '结构到马库什智能体的关联通路',
            1: '更高用量配额与更高性能模型',
            2: '内置科研记录系统',
            3: '全格式文件导出（FASTA、SDF、SMILES）',
            4: '额外专家智能体（知产报告、抗体抗原筛选、马库什撰写）',
            5: '共享项目与团队协作',
            6: '企业级安全与SSO及管理员控制',
            7: '专属客户支持',
        },
        recommendation: '推荐',
        upgradeButton: '联系我们',
    },
}

export const en = {
    personal_basic: {
        title: 'Upgrade',
        heading: 'Unlock Full Analysis Tools',
        description: 'This feature is exclusive to our Pro plan. Upgrade to take full control of your workflow.',
        features: {
            0: 'Up to 7.5X higher daily usage limit.',
            1: 'Expanded functionalities for Document Analysis (5 files/upload).',
            2: 'Export enabled for Lead Compound Analysis (5/month).',
            3: '5 Weekly AI-enabled Pulse Briefings.',
        },
        recommendation: 'Recommendation',
        upgradeButton: 'Upgrade to Pro',
    },
    personal_pro: {
        title: 'Upgrade',
        heading: 'Scale measurable value with our Enterprise package',
        description: 'Upgrade to access end-to-end scientific workflows and organizational collaboration.',
        features: {
            0: 'Connection from Structures to Markush agent.',
            1: 'Increased usage with higher-tier model performance.',
            2: 'Built-in system of record.',
            3: 'Full file exports (FASTA, SDF, SMILES).',
            4: 'Additional expert AI agents (Antibody Target Predictor, Markush Claim Drafting, Pharma CI Explorer).',
            5: 'Shared projects & team collaboration.',
            6: 'Enterprise security with SSO and admin controls.',
            7: 'Dedicated customer support.',
        },
        recommendation: 'Recommendation',
        upgradeButton: 'Contact Us',
    },
}

export const tw = {
    personal_basic: {
        title: '升級',
        heading: '解鎖完整分析工具',
        description: '此功能為專業版專屬。升級以全面掌控您的工作流程。',
        features: {
            0: '每日使用額度最高提升7.5倍',
            1: '文檔精讀功能擴展（每次至多上傳5個檔案）',
            2: 'Lead化合物分析開放導出（每月5次）',
            3: '5份AI驅動情報簡報（每週更新）',
        },
        recommendation: '推薦',
        upgradeButton: '升級至專業版',
    },
    personal_pro: {
        title: '升級',
        heading: '透過企業版釋放可量化的規模價值',
        description: '升級以獲取端到端科研工作流與組織級協作能力。',
        features: {
            0: '結構到馬庫什智能體的關聯通路',
            1: '更高用量配額與更高效能模型',
            2: '內建科研記錄系統',
            3: '全格式檔案導出（FASTA、SDF、SMILES）',
            4: '額外專家智能體（知產報告、抗體抗原篩選、馬庫什撰寫）',
            5: '共享專案與團隊協作',
            6: '企業級安全與SSO及管理員控制',
            7: '專屬客戶支援',
        },
        recommendation: '推薦',
        upgradeButton: '聯繫我們',
    },
}

export const jp = {
    personal_basic: {
        title: 'アップグレード',
        heading: 'フル分析ツールをアンロック',
        description: 'この機能はプロプラン限定です。アップグレードしてワークフローを完全にコントロールしましょう。',
        features: {
            0: '1日あたりの利用枠が最大7.5倍に拡大',
            1: 'ドキュメント精読機能を拡張（1回最大5ファイル）',
            2: 'Lead化合物分析のエクスポート機能を開放（月5回）',
            3: '5件のAI駆動インテリジェンスブリーフ（毎週更新）',
        },
        recommendation: 'おすすめ',
        upgradeButton: 'プロにアップグレード',
    },
    personal_pro: {
        title: 'アップグレード',
        heading: 'エンスをアンロックエンタープライズパッケージで測定可能な価値をスケール',
        description: 'アップグレードしてエンドツーエンドの科学ワークフローと組織コラボレーションを利用。',
        features: {
            0: '構造からマーカッシュエージェントへの連携パス',
            1: 'より多い利用枠と高性能モデル',
            2: '内蔵の研究記録システム',
            3: '全フォーマットファイルエクスポート（FASTA、SDF、SMILES）',
            4: '追加エキスパートエージェント（知財レポート、抗体抗原スクリーニング、マーカッシュ起草）',
            5: '共有プロジェクトとチームコラボレーション',
            6: 'エンタープライズセキュリティとSSO・管理者コントロール',
            7: '専任カスタマーサポート',
        },
        recommendation: 'おすすめ',
        upgradeButton: 'お問い合わせ',
    },
}
